import React from 'react';
import '../../App.css';
import SearchInput from '../search-Input';
import Table from './table';
import { useTranslation } from 'react-i18next';
import {Shimmer, ShimmerElementType} from 'office-ui-fabric-react';
import {anyObject,tFuncFuseSearch, tEnviroment, tFuncUpdateSPEntry, tFilterObject, tActiveFilters} from '../../types/typedefinitons';

const ClassicView:React.FC<{dataSet:anyObject, dropdownData:anyObject, doFuseSearch?:tFuncFuseSearch, isLoadingContent:boolean, searchActive:boolean, fuseOptions:anyObject, enviroment:tEnviroment, columnDefs:anyObject[], updateSharePointEntry:tFuncUpdateSPEntry, isAppAdmin:boolean, onLangChange:(targetLang:string)=>void, refreshAllData:()=>void, loadedContentLength:number, setSelectedValues:(action:string, changedValue?:tFilterObject) => void, selectedValues:tActiveFilters, view:string}> = (props) => {
    const {dataSet, dropdownData,  selectedValues, isLoadingContent, searchActive, fuseOptions, enviroment,columnDefs,updateSharePointEntry, isAppAdmin, onLangChange, refreshAllData, loadedContentLength, setSelectedValues, view} = props;
    const { t } = useTranslation();
    return(
    <>
    <div style={{padding:'20px'}}>
      {(Object.keys(dataSet).length > 0 && !isLoadingContent) || searchActive ?
      <>
      <SearchInput 
       rawData = {dropdownData}
      //  searchAction = {doFuseSearch}
       fuseOptions = {fuseOptions}
       setSelectedValues = {setSelectedValues}
       selectedValues = {selectedValues}
       view = {view}
       disabled={false}
      />
      {/* {enviroment.name !== 'public' ?
      <div style={{float:'right', textAlign:'right'}}>
      <span className="rs-internal-stamp">
      <img src="./images/stamp.png" width="96px" alt="DE"/>
      </span>
      </div>
      :
      null
      } */}

        <Table
          columns={columnDefs}
          values={dataSet}
          spChangeHandler = {updateSharePointEntry}
          isAppAdmin = {isAppAdmin}
          onLangChange = {onLangChange}
          onDataRefresh = {refreshAllData}
        />
        </> :
          <div className="rs-loading-container">
            <p className="rs-loading-text">{t('info.loading.progress', {length:loadedContentLength})}</p>
            <Shimmer
                shimmerElements={[
                  { type: ShimmerElementType.line, height: 40}
                ]}
                width={500}
                className="gemu-rs-shimmer-distance"
              />
              <Shimmer
                shimmerElements={[
                  { type: ShimmerElementType.line, height: 80}
                ]}
                className="gemu-rs-shimmer-distance"
              />
              <Shimmer
                shimmerElements={[
                  { type: ShimmerElementType.line, height: 300}
                ]}
                className="gemu-rs-shimmer-distance"
              />
          </div>
      }
    </div>
  </>
)
}
export default ClassicView;